import { getAppConfig } from '@services/config';

export const paths = {
    index: '/',
    plans: '/forfaits-mobiles/sans-engagement',
    packs: '/packs-divertissement/sans-engagement',
    fai: '/offres-internet/sans-engagement',
};

const appConfig = getAppConfig();

const INDEX_WEB_API = `${appConfig.siteRootUrl.url}/webapi/byou`;
export const localApiPaths = {
    auth: `${INDEX_WEB_API}/auth`,
    autocompleteCities: `${INDEX_WEB_API}/autocomplete/cities`,
    autocompleteStreets: `${INDEX_WEB_API}/autocomplete/streets`,
    autocompleteStreetNumbers: `${INDEX_WEB_API}/autocomplete/street-numbers`,
    checkMail: `${INDEX_WEB_API}/checkMail`,
    checkRio: `${INDEX_WEB_API}/checkRio`,
    createUser: `${INDEX_WEB_API}/create-user`,
    getUser: `${INDEX_WEB_API}/get-user-details`,
    delivery: `${INDEX_WEB_API}/delivery`,
    document: `${INDEX_WEB_API}/document`,
    eligibility: `${INDEX_WEB_API}/eligibility`,
    health: `${INDEX_WEB_API}/health`,
    revalidate: `${INDEX_WEB_API}/revalidate`,
    scanIban: `${INDEX_WEB_API}/scanIban`,
    sims: `${INDEX_WEB_API}/sims`,
};
